import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import styles from "./styles/ReminderTable.module.scss";
import {
  selectDashboardReminders,
  selectDashboardRemindersCount,
  selectDashboardRemindersLoading,
} from "Redux/Dashboard/slice";
import { FORMAT_MONTH_DATE_YEAR } from "Shared/Constants/app";
import { format, toCapitalize } from "Shared/Utils/shared";
import useReportsInnerPages from "Containers/Reports/ReportsInnerPages/useReportsInnerPages/useReportsInnerPages";
import { getValueOrDefault } from "Shared/Utils/fields";

export const useReminderTable = () => {
  const dashboardReminders = useSelector(selectDashboardReminders);
  const numPage = useSelector(selectDashboardRemindersCount);
  const { fullNameConvertor } = useReportsInnerPages();
  const loading = useSelector(selectDashboardRemindersLoading);

  const newTableBodyData = useMemo(
    () =>
      dashboardReminders.results.map((item) => {
        const status = getValueOrDefault(toCapitalize(item?.status).split("_").join(" "));
        const reminderType = getValueOrDefault(toCapitalize(item?.type).split("_").join(" "));
        return {
          id: getValueOrDefault(item.id),
          reminder_type: reminderType,
          associated_item: (
            <p className={styles.blueText}>{getValueOrDefault(item?.associated_item)}</p>
          ),
          due_date: getValueOrDefault(
            format(item.date || "", FORMAT_MONTH_DATE_YEAR)
          ),
          status: status,
          contact: getValueOrDefault(
            fullNameConvertor(
              item?.contact_first_name,
              item?.contact_last_name,
            )
          ),
        };
      }),
    [dashboardReminders],
  );
  return { newTableBodyData, loading, numPage, dashboardReminders };
};
